export default __webpack_public_path__ + "static/gamerize-5-c-3f10d739bcf44f186eab5c4cf69e5f7e.webp";